import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import OfoqAutoComplete from '../../../../components/Forms/OfoqAutoComplete'
import UseTranslation from '../../../../hooks/UseTranslation'

function StepTwo({ language, setLanguage, count }) {
  const { t } = UseTranslation()
  return (
        <Box sx={styles.root}>
            <Typography>
            {t?.['Please Select the Language you need to set for the']} <Typography component={'span'} sx={styles.count}> {count} </Typography> {t?.Users}.
            </Typography>
            <OfoqAutoComplete
              name={t?.Language}
              defaultOption={language}
              refState={setLanguage}
        optionsConfig={[{ name: 'Arabic', id: 1 }, { name: 'English', id: 2 }]}
              required
            />
        </Box>
  )
}
const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    p: { xs: '10px 5px', sm: '20px' },
  },
  count: { color: '#29CC8B', fontWeight: 'bold' },
}

export default StepTwo
